import Colors from '../../const/Colors';

export const ACTIVATION_AFFILIATION_TEXT =
  '*This brand is not affiliated with Special';
export const ACTIVATION_DEFAULT_AFFILIATION_TEXT_COLOR = Colors.white;
